import dayjs from '@helpers/dayjs'

export default function getTimezone() {
  return dayjs.tz.guess()
}
